interface CustomFilterIconProps {
  className?: string
  size?: number
  color?: string
}

export function CustomFilterIcon({ className, size = 24, color = 'currentColor' }: CustomFilterIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} className={className}>
      <rect x="2" y="6" width="20" height="2" rx="1" />
      <rect x="6" y="11" width="12" height="2" rx="1" />
      <rect x="9" y="16" width="6" height="2" rx="1" />
    </svg>
  )
}
